<template>
  <div>
    <el-table
        :data="keywords.data"
        :default-sort="{ prop: order_column, order: order_type }"
        class="w100"
        stripe
        v-loading="loading"
    >
      <el-table-column label="Label" prop="label" sortable></el-table-column>
      <el-table-column label="Licence Keys" prop="keywords" sortable></el-table-column>
      <el-table-column label="User" prop="requested_by" sortable>
        <template slot-scope="props">
          <span v-if="props.row.requested_by === null">/</span>
          <span v-else>{{props.row.requested_by.first_name}} {{props.row.requested_by.surname}}</span>
        </template>
      </el-table-column>
      <el-table-column label="Email" prop="requested_by" sortable>
        <template slot-scope="props">
          <span v-if="props.row.requested_by === null">/</span>
          <span v-else>{{props.row.requested_by.email}}</span>
        </template>
      </el-table-column>
      <el-table-column label="Date added" prop="requested_at" sortable>
        <template slot-scope="props">
          <span v-if="props.row.requested_at === null">/</span>
          <span v-else>{{props.row.requested_at | datetime}}</span>
        </template>
      </el-table-column>
      <el-table-column label="Status" prop="status" align="right" sortable>
        <template slot-scope="props">
          <div class="status-wrapper">
            <div v-if="props.row.status === 0" class="dot rejected"></div>
            <div v-else-if="props.row.status === 1" class="dot active"></div>
            <div v-else class="dot pending"></div>
            <el-select v-model="props.row.status" @change="handleStatusChange(props.row.id, props.row.status)">
              <el-option :label="'Disabled'" :value="0"></el-option>
              <el-option :label="'Active'" :value="1"></el-option>
              <el-option :label="'Pending'" :value="2"></el-option>
            </el-select>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('youtubeKeywords', [
      'keywords',
      'loading',
      'order_column',
      'order_type',
      'page_size'
    ])
  },

  methods: {
    ...mapMutations('youtubeKeywords', ['setPage', 'setDialog', 'setSelectedKeyword']),
    ...mapActions('youtubeKeywords', ['read', 'delete', "updateStatus"]),
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.read()
    },
    removeDialog(id) {
      this.$confirm(
          'You will remove this keyword. Continue?',
          'Warning',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
      )
          .then(() => {
            this.delete(id)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Unpublish cancelled'
            })
          })
    },
    handleStatusChange(id, value) {
      this.$confirm('Are you sure you want to change the status?', 'Confirmation', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.updateStatus({ id: id, status: value });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Status change cancelled'
        })
      });
    }
  },

  created() {
    this.read()
  }
}
</script>
<style scoped>
.status-wrapper {
  display: flex;
  align-items: center;
}
.dot {
  margin-right: 10px;
  width: 25px;
  height: 25px;
  border-radius: 100%;
}
.dot.rejected{background-color: #d06e6e}
.dot.active{background-color: #7dceaf}
.dot.pending{background-color: #999999}
</style>
